import { useCallback, useEffect, useState } from "react";
import { IVetModel } from "@fuse/models";
import vetService from "@fuse/services/vetService";

type ProfileState = { id: string; vet: IVetModel | null; loading: boolean; error: string };

export default function useVetProfile(id: string) {
	const [attempt, setAttempt] = useState(0);
	const [state, setState] = useState<ProfileState>({ id, vet: null, loading: true, error: "" });
	const retry = useCallback(() => setAttempt(value => value + 1), []);
	useEffect(() => {
		let current = true;
		setState({ id, vet: null, loading: true, error: "" });
		if (!id) {
			setState({ id, vet: null, loading: false, error: "This veterinarian could not be found." });
			return;
		}
		vetService.getSiteById(id)
			.then(response => {
				if (!current) return;
				const vet = response.result?.id === id ? response.result as IVetModel : null;
				setState({ id, vet, loading: false, error: vet ? "" : "This veterinarian could not be found." });
			})
			.catch(() => {
				if (current) setState({ id, vet: null, loading: false, error: "We couldn't load this veterinarian. Please try again." });
			});
		return () => { current = false; };
	}, [id, attempt]);
	return { ...(state.id === id ? state : { id, vet: null, loading: true, error: "" }), retry };
}
